// Featured Products Carousel Functionality
// Global carousel functions for featured products snippets

// Carousel state for each instance (global)
if (typeof window.carouselStates === "undefined") {
  window.carouselStates = {};
}

// Mobile carousel scroll function with native scrolling
if (typeof window.scrollMobileCarousel !== "function") {
  window.scrollMobileCarousel = function (carouselIndex, direction) {
    const index =
      typeof carouselIndex === "string"
        ? parseInt(carouselIndex, 10)
        : carouselIndex;
    const container = document.getElementById(
      "mobile-carousel-container-" + index
    );
    if (!container) return;

    // Scroll by approximately one card width (280px) + gap (16px)
    const scrollAmount = (280 + 16) * direction;
    container.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  };
}

// Update button states based on scroll position
if (typeof window.updateMobileCarouselButtons !== "function") {
  window.updateMobileCarouselButtons = function (carouselIndex) {
    const index =
      typeof carouselIndex === "string"
        ? parseInt(carouselIndex, 10)
        : carouselIndex;
    const container = document.getElementById(
      "mobile-carousel-container-" + index
    );
    const prevBtn = document.getElementById("prev-btn-" + index);
    const nextBtn = document.getElementById("next-btn-" + index);

    if (!container || !prevBtn || !nextBtn) return;

    const scrollLeft = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    // Disable prev button if at start
    prevBtn.disabled = scrollLeft <= 0;

    // Disable next button if at end (with small tolerance)
    nextBtn.disabled = scrollLeft >= maxScroll - 5;
  };
}

// Define scrollCarousel globally if not already defined
if (typeof window.scrollCarousel !== "function") {
  window.scrollCarousel = function (carouselIndex, direction) {
    const DEBUG_MODE = window.DEBUG_MODE || false;
    const index =
      typeof carouselIndex === "string"
        ? parseInt(carouselIndex, 10)
        : carouselIndex;
    if (DEBUG_MODE) console.log("scrollCarousel called:", index, direction);
    const carousel = document.getElementById("mobile-carousel-" + index);
    if (!carousel) {
      if (DEBUG_MODE) console.log("Carousel not found for index:", index);
      return;
    }

    const state = window.carouselStates[index];
    if (!state) {
      if (DEBUG_MODE) console.log("State not found for carousel:", index);
      return;
    }

    const items = carousel.children;
    state.totalSlides = items.length;
    const maxSlide = Math.max(1, state.totalSlides - 1);

    if (DEBUG_MODE)
      console.log(
        "Before scroll - currentSlide:",
        state.currentSlide,
        "direction:",
        direction,
        "maxSlide:",
        maxSlide
      );

    state.currentSlide += direction;
    state.currentSlide = Math.max(0, Math.min(state.currentSlide, maxSlide));

    if (DEBUG_MODE)
      console.log("After scroll - currentSlide:", state.currentSlide);

    // Calculate proper positioning based on actual card widths
    const containerPadding = 0; // px-4 padding is now on the container
    let translateX = containerPadding;

    // For subsequent cards, scroll to show the beginning of the card with padding
    if (state.currentSlide > 0) {
      // Calculate cumulative width of all previous cards
      let cumulativeWidth = 0;
      for (let i = 0; i < state.currentSlide; i++) {
        const prevCard = items[i];
        if (prevCard) {
          const prevCardRect = prevCard.getBoundingClientRect();
          cumulativeWidth += prevCardRect.width + 16; // card width + margin
        }
      }
      translateX = containerPadding - cumulativeWidth;
    }

    carousel.style.transform = `translateX(${translateX}px)`;

    const prevBtn = document.getElementById("prev-btn-" + index);
    const nextBtn = document.getElementById("next-btn-" + index);

    if (prevBtn) prevBtn.disabled = state.currentSlide === 0;
    if (nextBtn) nextBtn.disabled = state.currentSlide >= maxSlide;

    if (DEBUG_MODE)
      console.log(
        "Buttons disabled - prev:",
        prevBtn?.disabled,
        "next:",
        nextBtn?.disabled
      );
  };
}

// Define scrollDesktopCarousel globally if not already defined
if (typeof window.scrollDesktopCarousel !== "function") {
  window.scrollDesktopCarousel = function (carouselIndex, direction) {
    const DEBUG_MODE = window.DEBUG_MODE || false;
    const index =
      typeof carouselIndex === "string"
        ? parseInt(carouselIndex, 10)
        : carouselIndex;
    if (DEBUG_MODE)
      console.log("scrollDesktopCarousel called:", index, direction);
    const carousel = document.getElementById("desktop-carousel-" + index);
    if (!carousel) {
      if (DEBUG_MODE)
        console.log("Desktop carousel not found for index:", index);
      return;
    }

    const state = window.carouselStates[index];
    if (!state) {
      if (DEBUG_MODE)
        console.log("State not found for desktop carousel:", index);
      return;
    }

    const items = carousel.children;
    state.desktopTotalSlides = items.length;
    const containerWidth = carousel.parentElement.offsetWidth;

    // Calculate actual visible items based on container width
    let visibleItems = 4; // default
    let currentWidth = 0;

    for (let i = 0; i < items.length; i++) {
      const card = items[i];
      if (card) {
        const cardRect = card.getBoundingClientRect();
        const cardWidth = cardRect.width + 16; // card width + gap

        if (currentWidth + cardWidth <= containerWidth) {
          currentWidth += cardWidth;
        } else {
          break;
        }
      }
    }

    visibleItems = Math.max(1, Math.floor(currentWidth / 16)); // rough estimate
    const maxSlide = Math.max(1, state.desktopTotalSlides);

    if (DEBUG_MODE)
      console.log(
        "Before desktop scroll - currentSlide:",
        state.desktopCurrentSlide,
        "direction:",
        direction,
        "maxSlide:",
        maxSlide
      );

    state.desktopCurrentSlide += direction;
    state.desktopCurrentSlide = Math.max(
      0,
      Math.min(state.desktopCurrentSlide, maxSlide)
    );

    if (DEBUG_MODE)
      console.log(
        "After desktop scroll - currentSlide:",
        state.desktopCurrentSlide
      );

    // Calculate proper positioning based on actual card widths
    let translateX = 0;

    // For subsequent slides, scroll to show the beginning of the card with padding
    if (state.desktopCurrentSlide > 0) {
      // Calculate cumulative width of all previous cards
      let cumulativeWidth = 0;
      for (let i = 0; i < state.desktopCurrentSlide; i++) {
        const prevCard = items[i];
        if (prevCard) {
          const prevCardRect = prevCard.getBoundingClientRect();
          cumulativeWidth += prevCardRect.width + 16; // card width + gap
        }
      }
      translateX = -cumulativeWidth;
    }

    carousel.style.transform = `translateX(${translateX}px)`;

    const prevBtn = document.getElementById("desktop-prev-btn-" + index);
    const nextBtn = document.getElementById("desktop-next-btn-" + index);

    if (prevBtn) prevBtn.disabled = state.desktopCurrentSlide === 0;
    if (nextBtn) nextBtn.disabled = state.desktopCurrentSlide >= maxSlide;

    if (DEBUG_MODE)
      console.log(
        "Desktop buttons disabled - prev:",
        prevBtn?.disabled,
        "next:",
        nextBtn?.disabled
      );
  };
}

// Initialize carousel for a specific index
window.initFeaturedProductsCarousel = function (carouselIndex) {
  // Ensure carouselIndex is a number
  const index =
    typeof carouselIndex === "string"
      ? parseInt(carouselIndex, 10)
      : carouselIndex;

  // Initialize carousel state for this instance
  if (!window.carouselStates[index]) {
    window.carouselStates[index] = {
      currentSlide: 0,
      totalSlides: 0,
      isDragging: false,
      startX: 0,
      currentX: 0,
      startTranslate: 0,
      desktopCurrentSlide: 0,
      desktopTotalSlides: 0,
    };
  }

  // Initialize mobile button states on load
  const container = document.getElementById(
    "mobile-carousel-container-" + index
  );
  if (container) {
    // Initial button state
    if (typeof window.updateMobileCarouselButtons === "function") {
      window.updateMobileCarouselButtons(index);
    }

    // Update button states on scroll
    container.addEventListener("scroll", function () {
      if (typeof window.updateMobileCarouselButtons === "function") {
        window.updateMobileCarouselButtons(index);
      }
    });
  }

  // Initialize desktop and mobile button states
  setTimeout(function () {
    const state = window.carouselStates[index];

    if (state) {
      // Initialize desktop buttons - always disable prev button initially
      const desktopPrevBtn = document.getElementById(
        "desktop-prev-btn-" + index
      );
      const desktopNextBtn = document.getElementById(
        "desktop-next-btn-" + index
      );

      if (desktopPrevBtn) desktopPrevBtn.disabled = true; // Always start disabled for first slide
      if (desktopNextBtn) {
        // Check if there are enough items to scroll
        const desktopCarousel = document.getElementById(
          "desktop-carousel-" + index
        );
        if (desktopCarousel && desktopCarousel.children.length <= 4) {
          desktopNextBtn.disabled = true;
        }
      }

      // Initialize mobile buttons - always disable prev button initially
      const mobilePrevBtn = document.getElementById("prev-btn-" + index);
      const mobileNextBtn = document.getElementById("next-btn-" + index);

      if (mobilePrevBtn) mobilePrevBtn.disabled = true; // Always start disabled for first slide
      if (mobileNextBtn) {
        // Check if there are enough items to scroll
        const mobileCarousel = document.getElementById(
          "mobile-carousel-" + index
        );
        if (mobileCarousel && mobileCarousel.children.length <= 1) {
          mobileNextBtn.disabled = true;
        }
      }
    }
  }, 100);
};

// Product card logic
// Global function to handle customize button clicks
window.handleCustomizeClick = function (beadsSku, carabinerSku) {
  const isHomepage =
    window.location.pathname === "/" ||
    window.location.pathname === "/pages/home";

  if (isHomepage) {
    // On homepage: scroll to build-a-drip section and update configurator
    const buildADripSection = document.querySelector(
      '.build-a-drip-section, [id*="build"]'
    );

    if (buildADripSection) {
      // Scroll to the section
      buildADripSection.scrollIntoView({ behavior: "smooth", block: "start" });

      // Wait for scroll to complete, then update configurator selections
      setTimeout(function () {
        // Trigger configurator update with SKUs
        if (
          window.buildADripConfigurator &&
          typeof window.buildADripConfigurator.selectBySku === "function"
        ) {
          window.buildADripConfigurator.selectBySku(
            beadsSku,
            carabinerSku,
            "no-charm"
          );
        }
      }, 800);
    }
  } else {
    // Not on homepage: redirect to build-a-drip page with SKUs
    const url =
      "/pages/build-a-drip?bead=" +
      beadsSku +
      "&carabiner=" +
      carabinerSku +
      "&charm=no-charm";
    window.location.href = url;
  }
};

document.addEventListener("DOMContentLoaded", function () {
  // Only show videos on desktop devices
  function isDesktop() {
    return window.innerWidth >= 768; // md breakpoint
  }

  function isSafariBrowser() {
    var ua = navigator.userAgent || "";
    var vendor = navigator.vendor || "";
    // Treat Safari (including Mobile Safari) as Safari; exclude Chrome/Chromium/Edge on macOS/iOS
    var isAppleVendor = vendor.indexOf("Apple") > -1;
    var isSafariUA =
      /safari/i.test(ua) && !/chrome|crios|chromium|edg/i.test(ua);
    return isAppleVendor || isSafariUA;
  }

  function updateVideoVisibility() {
    const videos = document.querySelectorAll(".product-card-video");
    const fallbackImages = document.querySelectorAll(".product-fallback-image");

    videos.forEach(function (video) {
      const fallbackImage = video.parentElement.querySelector(
        ".product-fallback-image"
      );

      if (isDesktop()) {
        // Add source tag only on desktop if not already added
        if (!video.querySelector("source")) {
          var safari = isSafariBrowser();
          var webmSrc = video.dataset.videoSrcWebm;
          var movSrc = video.dataset.videoSrcMov;

          var chosenSrc = null;
          var chosenType = null;

          if (safari && movSrc) {
            chosenSrc = movSrc;
            chosenType = "video/quicktime; codecs=hvc1";
          } else if (webmSrc) {
            chosenSrc = webmSrc;
            chosenType = "video/webm; codecs=vp9, opus";
          } else if (movSrc) {
            // Fallback to MOV if WEBM missing
            chosenSrc = movSrc;
            chosenType = "video/quicktime; codecs=hvc1";
          }

          if (chosenSrc) {
            const source = document.createElement("source");
            source.src = chosenSrc;
            if (chosenType) source.type = chosenType;
            video.appendChild(source);
            video.load(); // Load the video with the new source
          }
        }
        // Show video on desktop
        video.style.display = "block";
        if (fallbackImage) {
          fallbackImage.style.display = "none";
        }
      } else {
        // Hide video on mobile (don't add source)
        video.style.display = "none";
        if (fallbackImage) {
          fallbackImage.style.display = "block";
        }
      }
    });
  }

  // Initial setup
  updateVideoVisibility();

  // Handle window resize
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateVideoVisibility, 250);
  });

  // Handle video hover behavior for product cards
  const productCardVideos = document.querySelectorAll(".product-card-video");

  productCardVideos.forEach(function (video) {
    const productCard = video.closest(".group");

    if (productCard) {
      // Ensure video is paused initially
      video.pause();

      // Play on hover anywhere on the card
      productCard.addEventListener("mouseenter", function () {
        if (isDesktop()) {
          video.play();
        }
      });

      // Pause when mouse leaves the card and go back to first frame
      productCard.addEventListener("mouseleave", function () {
        video.pause();
        video.currentTime = 0;
      });
    }
  });
});
